// extracted by mini-css-extract-plugin
export default {"price":"M4-z","onSale":"N4-z","msrpLabelPrice":"O4-z","msrpLabel":"P4-z","originalPrice":"Q4-z","percentOff":"R4-z"};